import styled from 'styled-components';

export const Container = styled.section`
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  min-width: 250px;
  max-width: 650px;
  position: relative;
`;
Container.displayName = 'Container';

export const Frame = styled.div`
  position: absolute;
`;
Frame.displayName = 'Frame';

export const FrameContainer = styled.div`
  align-items: center;
  display: flex;
  height: 348px;
  justify-content: center;
  position: relative;
  width: 592px;
`;
FrameContainer.displayName = 'FrameContainer';

export const Logo = styled.img``;
Logo.displayName = 'Logo';

export const Time = styled.div`
  color: #ffffff;
  font-size: 96px;
  font-weight: bold;
  letter-spacing: 1px;
  position: relative;
  text-align: center;
  top: 16px;
  -webkit-text-stroke: 4px black;
`;
Time.displayName = 'Time';
